import * as React from "react";
import { GlobalAuthorization } from "../misc/components/Authorization";
import { useSecurityContext } from "../Core/SecurityContext";
import { PermissionEnum } from "../misc/api/ApiPermissionEnum";
import { useWebPortalLegacyClient } from "../misc/api/WebPortalTokenClient";

export const AdminHome = () => {
    const [helpDocumentation, setHelpDocumentation] = React.useState<string>();
    const { currentUserPermissions } = useSecurityContext();
    const legacyClient = useWebPortalLegacyClient();

    React.useEffect(() => {
        const getData = () => {
            legacyClient.getAdminCore()
                .then(json => {
                    setHelpDocumentation(json.HelpDocumentationUrl);
                })
        }

        getData();
    }, []);

    return (
        <>
            <GlobalAuthorization currentPermissions={currentUserPermissions} permissionId={PermissionEnum.AccessAdmin}>
                <div className="row">
                    <div className="col-md-6">
                        <h2 className="text-primary">Administration Page</h2>
                    </div>
                    <div className="col-md-6 h2">
                        <a href={helpDocumentation} target="_blank" className="pull-right">
                            <i className="fas fa-lg fa-question-circle"></i>
                        </a>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="panel">                    
                            <div className="panel-body">
                                Welcome to the Administration dashboard
                            </div>
                        </div>
                    </div>
                </div>
            </GlobalAuthorization>
        </>
    );
}
